export const PROXY_PORT = 8000;

function isDenoEnvironment() {
  return typeof Deno !== "undefined";
}
const HOSTNAME = "https://test.planning.ingka.com";
const COOKIE = isDenoEnvironment() ? Deno.env.get("D_COOKIE") : "";

if (!COOKIE && isDenoEnvironment()) {
  console.error("Please provide a COOKIE environment variable");
  Deno.exit(1);
}

const getAccessTokenMiddleware = async (req: Request): Promise<string> => {
    const accessTokenCookie = (req as any).cookies && (req as any).cookies.get('access_token');
  
    if (!accessTokenCookie) {
      const { access_token } = await requestAccessToken();

      return access_token
    }
  }
  
  // deno-lint-ignore no-inner-declarations
  async function requestAccessToken(): Promise<{
    access_token: string;
    expires_in: number;
  }> {
    const response = await fetch(Deno.env.get('OAUTH_URL') ?? '', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'client_credentials',
        client_id: Deno.env.get('OAUTH_CLIENT_ID') ??'',
        client_secret: Deno.env.get('OAUTH_CLIENT_SECRET') ?? '',
        audience: Deno.env.get('OAUTH_AUDIENCE') ?? '',
        scope: Deno.env.get('OAUTH_SCOPE') ?? '',
      }),
    });
  
    return await response.json();
  }

export const handler = async (req: Request): Promise<Response> => {
  const url = new URL(req.url);
  const { pathname, search } = url;

  const cookie = await getAccessTokenMiddleware(req) ?? '';

  try {
    const targetURL = `${HOSTNAME}${pathname}${search}`;
    const response = await fetch(targetURL, {
      method: req.method,
      headers: {
        ...req.headers,
        cookie: `ingkaref=${cookie}`,
      },
      body: req.body,
    });

    return new Response(response.body, {
      status: 200,
      // statusText: response.statusText,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": response.headers.get("content-type") || "text/html",
      },
    });
  } catch (error) {
    return new Response(`Error: ${(error as Error).message}`, { status: 500 });
  }
};

if (isDenoEnvironment()) {
  console.log("Proxy server is running on http://localhost:8000");
  Deno.serve({ port: PROXY_PORT }, handler);
}
